<template>
  <div class="c-progress">
    <div class="c-progress__type">
      <span class="o-ico o-ico--star o-ico--s">
        <svg>
          <use xlink:href="#svg-icon-progress"></use>
        </svg>
      </span>
      <p class="c-progress__number">{{ label }}</p>
    </div>
    <div class="c-progress__bar-wrap">
      <span class="c-progress__bar" :style="progressBarStyle">
        <span class="c-progress__bar__number">{{ progressValue }}</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      required: true
    },
    progressValue: {
      type: Number,
      required: true
    },
    progressPercent: {
      type: Number,
      required: true
    },
    progressColor: {
      type: String,
      required: true
    }
  },

  computed: {
    progressBarStyle () {
      return `width: ${this.progressPercent}%; background-color: ${this.progressColor};`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CProgress.vue